import { initialState } from "./globalSlice";

const storeMigrations = {
  0: (prevState) => {
    return {
      ...prevState,
      user: initialState.user,
    };
  },
  1: (prevState) => {
    return {
      ...prevState,
      user: initialState.user,
    };
  },
  2: (prevState) => {
    return {
      ...prevState,
      store: initialState.store,
    };
  },
  3: (prevState) => {
    return {
      ...prevState,
      departmentFilters: initialState.departmentFilters,
    };
  },
  4: (prevState) => {
    return {
      ...prevState,
      store: initialState.store,
    };
  },
  5: (prevState) => {
    return {
      ...prevState,
      store: initialState.store,
    };
  },
  6: (prevState) => {
    return {
      ...prevState,
      itemFilters: initialState.itemFilters,
    };
  },
  7: () => {
    return {
      ...initialState,
    };
  },
};

export default storeMigrations;
